import { Checkbox } from '@components/Checkbox/Checkbox';
import { Pressable } from 'react-native';
import { XStack } from 'tamagui';
import { FieldTitle } from '@components/FieldTitle/FieldTitle';

interface CheckboxFieldProps {
  /** Field label (displayed next to the checkbox) */
  label?: string;
  /** Current checked state */
  checked: boolean;
  /** Callback when checked state changes */
  onCheckedChange: (checked: boolean) => void;
  /** Whether the field is required */
  required?: boolean;
}

/**
 * CheckboxField - A checkbox field with label
 *
 * Features:
 * - Clickable checkbox with visual feedback
 * - Label displayed next to the checkbox
 * - Required indicator (*)
 *
 * @example
 * <CheckboxField
 *   label="Inaccurate location"
 *   checked={inaccurateLocation}
 *   onCheckedChange={setInaccurateLocation}
 * />
 */
export const CheckboxField = ({
  label,
  checked,
  onCheckedChange,
  required = false,
}: CheckboxFieldProps): React.ReactElement => {
  const handleLabelPress = (): void => {
    onCheckedChange(!checked);
  };

  return (
    <XStack gap="$2" alignItems="center" paddingHorizontal="$2">
      <Checkbox
        checked={checked}
        onCheckedChange={onCheckedChange}
        ariaLabel={label}
      />
      <Pressable onPress={handleLabelPress}>
        <FieldTitle label={label} required={required} fontFamily="$body" />
      </Pressable>
    </XStack>
  );
};
